import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMethod } from "../../../../Service/ApiCallMethod";

// Async thunk to fetch conversation metrics
export const getConversationMetrics = createAsyncThunk(
  "dashboard/conversation-metrics",
  async (assistantId, thunkAPI) => {
    try {
      const response = await getMethod(
        `user/dashboard/conversation-metrics${
          assistantId && assistantId != "all"
            ? `?assistantId=${assistantId}`
            : ""
        }`
      );
      const data = await response.data;
      if (response.status !== 200 && response.status !== 201) {
        // Handle non-2xx HTTP responses
        return thunkAPI.rejectWithValue(data.message || "Something went wrong");
      }
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);

// Initial state for the conversation metrics slice
const initialState = {
  conversationMetricsData: null,
  loading: false,
  error: null,
};

// Redux slice for managing conversation metrics
export const GetConversationMetricsSlice = createSlice({
  name: "dashboard/conversation-metrics",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getConversationMetrics.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getConversationMetrics.fulfilled, (state, action) => {
        state.loading = false;
        state.conversationMetricsData = action.payload;
        state.error = null;
      })
      .addCase(getConversationMetrics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetConversationMetricsSlice.reducer;
